import api from './index'

/**
 * 获取数据总览头部数据
 * @returns
 */
export const getAllData = () => {
  return api({ url: '/admin/dataview/view' })
}

/**
 * 获取实时数据
 * @param {*} data
 * @returns
 */
export const getWeekData = (data) => {
  return api({ url: '/admin/dataview/real', data })
}

/**
 * 获取省份
 * @returns
 */
export const getProvince = () => {
  return api({ url: '/admin/dataview/province' })
}
/**
 * 获取访客次数
 * @param {*} data
 * @returns
 */
export const getVisitCount = (data) => {
  return api({ url: '/admin/dataview/hot/visitor', data })
}

/**
 * 获取用户来源
 * @param {*} data
 * @returns
 */
export const getUserOrigin = (data) => {
  return api({ url: '/admin/dataview/user', data })
}
/**
 * 获取热门资讯
 * @param {*} data
 * @returns
 */
export const getHotMessage = (data) => {
  return api({ url: '/admin/dataview/hot/consult', data })
}

/**
 * 获取访问时刻数据
 * @param {*} data
 * @returns
 */
export const getVisitData = (data) => {
  return api({ url: '/admin/dataview/time', data })
}

/**
 * 获取套餐信息
 * @returns
 */
export const getComboInfo = () => {
  return api({ url: 'admin/combo/info' })
}
